import styled from "styled-components";

export const List = styled.ul`
  list-style: none;
  padding: 1rem 0;
`;

export const Text = styled.li`
  display: flex;
  align-items: center;
  gap: .5rem;

  p {
    padding: .3rem 0;
    font-size: 0.8rem;
  }

`;

export const Container = styled.main`
  margin: 2rem 4rem;
  h2 {
    text-align: center;
  }

  section {
    margin: 1rem auto;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    max-width: 50rem;
  }

  .buttons {
    margin: 1rem 0;
    display: flex;
    gap: 1rem;
  }

  .content {
    margin: 0 auto 1.5rem auto;
    max-width: 1100px;
    padding: 1rem 1.5rem;
    background-color: #fff;
    border-radius: 10px;

    .form {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      /* justify-content: center; */
    }
  }
`;
